<template>
	<validation-provider
			:name="'AdminSelectTrainingModuleCode-' + contentKey + '-' + inputItemKey"
			:rules="getValidationRules(contents[contentKey].inputItems[inputItemKey].rules)"
			v-slot="{ errors }">
		<v-autocomplete
				v-model="$store.state.admin.input[inputItemKey]"
				:items="arrayObject($_admnSlctTrnMdlId_stateAdminTrainings())"
				item-text="key"
				item-value="key"
				placeholder="Training Module Code"
				@change="$_admnSlctTrnMdlId_setAdminState()"
				:error-messages="errors" />
	</validation-provider>
</template>

<script>
	export default {
		name: 'AdminSelectTrainingModuleCode',
		props: {
			contentKey: String,
			inputItemKey: String,
			contents: Object,
			inits: Object
		},
		computed: {
			$_admnSlctTrnMdlId_stateAdminTrainings() {
				const self_ = this;
				return () => {
					const input_ = self_.getAdminState('input')
					const courseCode_ = input_.trainingCourseCode;

					if(self_.isFalse(courseCode_)) { return null }

					const trainings_ = self_.getAdminState('trainings')
					return trainings_[courseCode_].modules
				}
			}
		},
		methods: {
			$_admnSlctTrnMdlId_getTraining(param) {
				const self_ = this;

				const trainings_ = self_.getAdminState('trainings')

				const input_ = self_.getAdminState('input')
				const courseCode_ = input_.trainingCourseCode;
				const moduleCode_ = input_[self_.inputItemKey]
				if(self_.isFalse(courseCode_) || self_.isFalse(moduleCode_)) { return null }

				return trainings_[courseCode_].modules[moduleCode_][param]
			},
			$_admnSlctTrnMdlId_setAdminState() {
				const self_ = this;

				self_.$_admnSlctTrnMdlId_setAdminStateInput()
				self_.$_admnSlctTrnMdlId_setAdminStateTrainings()
			},
			$_admnSlctTrnMdlId_setAdminStateInput() {
				const self_ = this;

				let input_ = self_.getAdminState('input')
				input_.trainingModuleTitle = self_.getLangsVal(self_.$_admnSlctTrnMdlId_getTraining('title'))

				self_.setAdminState('input', input_)
			},
			$_admnSlctTrnMdlId_setAdminStateTrainings() {
				const self_ = this;

				let trainings_ = self_.getAdminState('trainings')

				const input_ = self_.getAdminState('input')
				const courseCode_ = input_.trainingCourseCode;
				const moduleCode_ = input_[self_.inputItemKey]

				if(self_.isFalse(courseCode_) || self_.isFalse(moduleCode_) || !self_.isEmpty(trainings_[courseCode_].modules[moduleCode_].sections)) { return null }

				Promise.resolve().then(() => {
					return self_.getFirestoreSubSubCollection('trainings', courseCode_, 'modules', moduleCode_, 'sections')
				}).then(result => {
					trainings_[courseCode_].modules[moduleCode_].sections = result;
					self_.setAdminState('trainings', trainings_)
				})
			}
		}
	}
</script>

<style scoped>
</style>
